module.exports = __webpack_public_path__ + "img/home_menu_11_selected.52935466.png";